/**
 * Icono de una métrica en círculo de color (spec 009-dashboard-camino, FR-002)
 */

import { cn } from '@/lib/utils';
import { METRIC_ICONS } from './metricIcons';
import type { MetricKey } from './metricIcons';

interface MetricIconProps {
  metric: MetricKey;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE = {
  sm: { circle: 'h-8 w-8', icon: 'h-4 w-4' },
  md: { circle: 'h-10 w-10', icon: 'h-5 w-5' },
  lg: { circle: 'h-[52px] w-[52px]', icon: 'h-6 w-6' },
};

export function MetricIcon({ metric, size = 'md', className }: MetricIconProps) {
  const { icon: Icon, circle, color } = METRIC_ICONS[metric];
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex flex-none items-center justify-center rounded-full',
        SIZE[size].circle,
        circle,
        color,
        className
      )}
    >
      <Icon className={SIZE[size].icon} strokeWidth={1.8} />
    </span>
  );
}
